export type EmptyStateProps = {
    description: string;
    image: React.Node;
};

export default function EmptyState({ description, image }: EmptyStateProps) {
    return (
        <div className="w-full h-full flex flex-col justify-center items-center gap-y-8">
            {image}
            <span>{description}</span>
        </div>
    );
}

export function EmptyStateSpinner() {
    return (
        <EmptyState
            description=""
            image={
                <img
                    src="/img/spinner.png"
                    className="w-[50px] h-[50px] animate-spin"
                />
            }
        />
    );
}
